import React from 'react';
import Grid from '@material-ui/core/Grid';
import { SelectValue } from '../index';
import { Button } from './Button';

export interface ButtonsProps<T = string> {
  options: SelectValue<T>[];
  value?: T;
  disabled?: boolean;
  onChange?: (value: SelectValue<T> | undefined) => void;
}

export function Buttons<T>({ value, options, onChange, disabled }: ButtonsProps<T>) {
  if (!options.length) {
    return null;
  }
  return (
    <Grid container spacing={2}>
      {options.map((option) => {
        const selected = isSelected(option, value);
        return (
          <Grid item xs key={option.key}>
            <Button
              color={selected ? 'primary' : 'default'}
              disabled={disabled}
              fullWidth
              onClick={() => {
                onChange?.(!selected ? option : undefined);
              }}
            >
              {option.label}
            </Button>
          </Grid>
        );
      })}
    </Grid>
  );
}

function isSelected<T>(option: SelectValue<T>, value?: T): boolean {
  if (!value || !option.value) {
    return false;
  }
  try {
    return JSON.stringify(option.value) === JSON.stringify(value);
  } catch (e) {
    return false;
  }
}
